//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vInput from '~/mixins/vInput'
import adaptiveElement from '~/mixins/adaptiveElement'

const defaultComponentIsList = {
  wrapper: 'div',
  container: 'div',
  title: 'div',
  errors: 'div',
  inputContainer: 'div',
  icon: 'div',
  prefix: 'span',
  list: 'div'
}

export default {
  name: 'VSelect',
  components: {},
  mixins: [vInput, adaptiveElement],
  props: {
    ...vInput.props,
    options: {
      type: [Array, Function],
      default: () => []
    },
    labelParams: {
      type: Array,
      default: () => []
    },
    param: {
      type: String,
      default: ''
    },
    arrowIcon: {
      type: String,
      default: 'select-arrow'
    },
    selectPl: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: String,
      default: ''
    },
    adaptiveList: {
      type: [Boolean, Object],
      default: false
    },
    absoluteList: {
      type: Boolean,
      default: true
    },
    multiply: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isOpen: false,
    style: {},
    list_: {
      state: true,
      show: false,
      prevChoice: null,
      curId: 0,
      value: '',
      valuePrev: '',
      loading: false,
      list: undefined,
      style: {}
    }
  }),
  computed: {
    getLink: app => (option) => {
      if (option && option.route) {
        return app.$router.resolve({ ...app.$route, ...option.route }).href
      }
      return '#'
    },
    activeOption () {
      if (this.options.length) {
        if (this.multiply) {
          return this.options.filter(o => this.model?.includes(o[this.param ? this.param : 'id']))
        }
        if (this.model || (this.allowZero && this.model === 0)) {
          return this.options.find(o => o[this.param ? this.param : 'id'] === this.model)
        } else if (this.placeholder) {
          return this.placeholder
        } else {
          return this.options[0]
        }
      }
      return null
    },
    getPlaceholder () {
      const result = []
      const obj = {}
      if (this.pseudoLabel) {
        return ''
      }
      obj[this.param ? this.param : 'id'] = 0
      obj.name = this.placeholder || 'Select'
      result.push(obj)
      return result
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        if (this.multiply) {
          if (this.value.includes(value)) {
            this.$emit('input', this.value?.filter(v => v !== value))
          } else {
            this.$emit('input', [...this.value || [], value])
          }
        } else {
          this.$emit('input', value)
        }

        if (this.form) {
          this.form.errors.clear(this.field ? this.field : this.name)
        }
      }
    }
  },
  watch: {
    isOpen () {
      if (!this.isOpen) {
        this.setHover(false)
      }
    }
  },
  methods: {
    setListStyle (params) {
      this.style = {
        ...params
      }
    },
    openList () {
      setTimeout(() => {
        this.isOpen = true
      }, 100)
    },
    handleWindowScroll () {
      if (this.adaptiveList) {
        this.getAdaptivePosition({
          ctx: this, el: this.$refs.list, parEl: this.$refs.container, callback: this.setListStyle
        })
      }
    },
    callGetAdaptivePosition (type = null) {
      if (this.adaptiveList) {
        this.getAdaptivePosition({
          ctx: this,
          el: this.$refs.list,
          callback: (params = {}) => this.setListStyle({
            '--adaptive-opacity': 1, ...params
          }),
          fixed: this.absoluteList,
          parEl: this.$el,
          realParEl: this.$el,
          data: this.list_.list,
          model: this.model,
          type
        })
      }
    },
    setActive (option) {
      this.isOpen = this.multiply
      if (this.itemType === 'link') {
        return
      }
      this.setBlur()
      this.model = option[this.param ? this.param : 'id']
      this.$emit('selected', option)
      this.$emit('change', option)
    },
    close () {
      if (this.isOpen) {
        this.$nextTick(() => {
          this.isOpen = false
          window.removeEventListener('scroll', this.handleWindowScroll)
        })
        setTimeout(() => {
          this.setHover(false)
        }, 1000)
      }
    },
    toggle () {
      this.isOpen = !this.isOpen

      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.isOpen) {
            if (this.adaptiveList) {
              this.getAdaptivePosition({
                ctx: this, el: this.$refs.list, parEl: this.$refs.container, callback: this.setListStyle
              })
            }
            window.addEventListener('scroll', this.handleWindowScroll)
          } else {
            window.removeEventListener('scroll', this.handleWindowScroll)
          }
        })
      })
    }
  }
}
